module.exports = __webpack_public_path__ + "img/medMission_041022_E.9a2da25a.jpg";